import { toast } from "sonner";
import { errorMessage } from "@/api/client";
import { useUpdateOrganization } from "@/api/mutations";
import { usePermissions } from "@/auth/permissions";
import { Button } from "@/components/ui/button";
import { Spinner } from "@/components/ui/spinner";

/** One click to turn the organization's Offer API on (where an integration is blocked by it). */
export function TurnOnOfferApi({ organizationId }: { organizationId: string }) {
  const { can } = usePermissions();
  const update = useUpdateOrganization(organizationId);
  if (!can("organizations:update")) return null;
  return (
    <Button
      size="xs"
      variant="outline"
      disabled={update.isPending}
      onClick={() =>
        update.mutate(
          { offerApi: true },
          {
            onSuccess: () => toast.success("Offer API turned on"),
            onError: (err) => toast.error("Couldn't turn it on", { description: errorMessage(err) }),
          },
        )
      }
    >
      {update.isPending ? <Spinner data-icon="inline-start" /> : null}
      Turn on Offer API
    </Button>
  );
}
